<kendo-dropdownlist
  class="filter-dropdown"
  [attr.data-private]="config.isStudentOrGuide"
  [data]="templateOptions$ | async"
  [style.width]="width"
  textField="label"
  valueField="value"
  [popupSettings]="{ width: 'auto', height: 320 }"
  [listHeight]="320"
  [value]="defaultValue$ | async"
  [disabled]="config?.disabled() | async"
  (valueChange)="updateSelection($event.value, !config?.storageHandler)"
>
  <ng-template kendoDropDownListValueTemplate let-dataItem>
    <ng-container *ngIf="dataItem">
      <ng-container *ngIf="hasLogo; else defaultValueTemplate">
        <ng-container *ngIf="defaultValue$ | async as option">
          <span class="k-text-nowrap">
            <span [attr.data-private]="config.isStudentOrGuide" class="option-with-logo"> {{ option?.label }} </span>
            <img
              [attr.data-private]="config.isStudentOrGuide"
              *ngIf="option?.logoUrl"
              [src]="option.logoUrl"
              alt=""
              class="option-logo"
              height="100%"
              width="100%"
            />
          </span>
        </ng-container>
      </ng-container>

      <ng-template #defaultValueTemplate>
        <span class="k-text-nowrap" [attr.data-private]="config.isStudentOrGuide">{{ dataItem?.label }}</span>
      </ng-template>
    </ng-container>
  </ng-template>

  <ng-template kendoDropDownListItemTemplate let-dataItem>
    <ng-container *ngIf="!config.transform; else defaultItemTemplate">
      <div [attr.data-private]="config.isStudentOrGuide">
        <span class="k-text-nowrap">
          <span>{{ dataItem.label }}</span>
          <img
            *ngIf="dataItem.logoUrl"
            [src]="dataItem.logoUrl"
            alt=""
            class="option-logo"
            height="100%"
            width="100%"
          />
          <span *ngIf="dataItem.alphaStudentId" class="option-with-id k-ml-1">({{ dataItem.alphaStudentId }})</span>
        </span>
      </div>
    </ng-container>

    <ng-template #defaultItemTemplate>
      <span class="k-text-nowrap">{{ dataItem.label }}</span>
    </ng-template>
  </ng-template>

  <ng-template kendoDropDownListNoDataTemplate>
    <h1 class="k-h6">
      <span class="k-icon k-i-exclamation-circle"></span><br /><br />
      No data here
    </h1>
  </ng-template>
</kendo-dropdownlist>
